<template>
  <div class="content" id="sobre">
    <b-container>
      <div class="conteudo">
        <div class="textoContent">
          <h1 class="titulo">Sobre</h1>
          <p>
            Graduado em Análise e Desenvolvimento de Sistemas pela Fatec
            Guaratinguetá, atuando como analista de QA e desenvolvedor web
            freelancer, especializado na criação de soluções personalizadas,
            utilizando as melhores práticas e tecnologias atuais para atender às
            necessidades dos clientes.
          </p>
          <a :href="contato" target="_blank"
            ><button class="btnContato">Entre em contato</button></a
          >
        </div>

        <div class="imgContent">
          <img :src="imagem" class="imagem" alt="Site em tela" />
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "SobreVue",

  data() {
    return {
      imagem: "./images/mkp.png",
      contato: "https://api.whatsapp.com/send?phone=5512997068967",
    };
  },
};
</script>

<style scoped>
body {
  max-width: 1280px;
}
.content {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  height: 600px;
  width: auto;
  margin-bottom: 5%;
}
.textoContent {
  width: 50%;
  height: 600px;
  background-color: #989a9a;
  color: #fff;
  padding: 7%;
  text-align: left;
  border-radius: 20px 0px 0px 20px;

  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
}
.btnContato {
  color: #fff;
  background-color: #32dd76;
  border-radius: 7px;
  padding: 12px;
  font-size: 22px;
  width: 300px;
  border: solid 1px #32dd76;
  cursor: pointer;
  transition: all 0.3s;
  -webkit-transition: width 1s;
  transition: width 1s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
  float: left;
  font-family: "Montserrat-VariableFont_wght" !important;
}
a {
  font-family: "Montserrat-VariableFont_wght" !important;
}

@font-face {
  font-family: Montserrat-VariableFont_wght;
  src: url("~@/assets/Montserrat-VariableFont_wght.ttf");
}
.btnContato:hover {
  background-color: #fff;
  color: #32dd76;
  border: solid 1px #32dd76;
  transform: scale(1.1);
}

.imgContent {
  width: 50%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
    0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
    0 16px 16px rgba(0, 0, 0, 0.12);

  border-radius: 0px 20px 20px 0px;

  display: flex;
  align-items: center;
}
.imagem {
  width: 100% !important;
}

.conteudo {
  display: flex;
  flex-direction: row;
}

@media only screen and (max-width: 869px) {
  .content {
    background-color: #fff;
    display: flex;
    flex-direction: column !important;
    height: 600px;
    width: auto;
    margin-bottom: 5%;
  }
  .textoContent {
    width: 100%;
    height: 600px;
    background-color: #989a9a;
    color: #fff;
    padding: 7%;
    text-align: left;
    border-radius: 20px;

    transition: all 0.3s;
    -webkit-transition: width 1s;
    transition: width 1s;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.12),
      0 4px 4px rgba(0, 0, 0, 0.12), 0 8px 8px rgba(0, 0, 0, 0.12),
      0 16px 16px rgba(0, 0, 0, 0.12);

    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
  }

  .imgContent {
    display: none;
  }
  .imagem {
    width: 100% !important;
  }

  .conteudo {
    display: flex;
    flex-direction: column;
  }
}
</style>
